import React from "react";
import { Container, StyledPagination } from "./styles";

interface PaginationProps {
	totalItems: number;
	pageSize: number;
	page: number;
	onPageChange: (page: number) => void;
	siblingCount?: number;
	boundaryCount?: number;
}

const Pagination = ({
	totalItems,
	pageSize,
	page,
	onPageChange,
	siblingCount = 1,
	boundaryCount = 1
}: PaginationProps) => {
	const safePageSize = Math.max(1, pageSize);
	const count = Math.ceil(totalItems / safePageSize);

	if (count <= 1) {
		return null;
	}

	return (
		<Container spacing={2}>
			<StyledPagination
				count={count}
				page={Math.min(Math.max(1, page), count)}
				onChange={(_, value) => onPageChange(value)}
				siblingCount={siblingCount}
				boundaryCount={boundaryCount}
			/>
		</Container>
	);
};

export default Pagination;
